import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { DetailDialogComponent } from '../detail-dialog/detail-dialog.component';

/**Service file */
import { SideNavService } from '../../../sidenav.service';
import { EcommerceOrderService } from '../../../../../order/order.service';

/** Local file */
import { displayValues, toastMsg, trashOrderStatus, checkoutFields } from '../../../../../../utils/index';

// Local component
import { FuseConfirmDialogComponent } from '../../../../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ToastComponent } from '../../../../../../common/toast.component';

@Component({
  selector: 'app-customer-toggle-request',
  templateUrl: './customer-toggle-request.component.html',
  styleUrls: ['./customer-toggle-request.component.scss']
})
export class CustomerToggleRequestComponent implements OnInit {

  displayedColumns = [

    'orderId',
    'insreportid',
    'scheduleRequestDate',
    'contactName',
    'propertyAddress',
    'contactEmail',
    'contactPhone',
    'additionalShare',
    'detailsButton',

  ];


  displayValues = displayValues;
  toastMsg = toastMsg;
  trashOrderStatus = trashOrderStatus;
  checkoutFields = checkoutFields;

  onScheduleRequestChangedSubscription: Subscription;
  finalScheduleRequestChangedSubscription: Subscription;

  isLoading: boolean = false;
  isLoadingResults = false;
  isRateLimitReached = false;
  endCursor: string;
  hasNextPage: boolean = false

  scheduleRequestSource: MatTableDataSource<RequestedOrdersData>;
  @ViewChild(MatPaginator) scheduleRequestPaginator: MatPaginator;
  @ViewChild(MatSort) scheduleRequestSort: MatSort;

  selectedId: any;


  private allRequestedOrders: any = [];
  public orderCount: number = 0;

  currentPageIndex: number = 0;

  pageSize: number = 10; //Initially load 10 by 10 per page
  from: string;

  constructor(
    public sideNavService: SideNavService,
    public ecommerceOrderService: EcommerceOrderService,
    public dialog: MatDialog


  ) {
    this.sideNavService.fetchOrderStatus('initial', '');
  }
  ngOnInit() {

    this.onScheduleRequestChangedSubscription =
      this.sideNavService.onScheduleRequestChanged
        .subscribe(response => {
          this.endCursor = '';
          this.hasNextPage = false;
          this.isLoading = this.allRequestedOrders.length == 0 ? true : false;

          if (!response.loading) {

            this.endCursor = response.endCursor;
            this.hasNextPage = response.hasNextPage;
            this.from = response.from;

            this.allRequestedOrders = this.allRequestedOrders.length == 0
              ? response.scheduleRequestOrders :
              this.allRequestedOrders.concat(response.scheduleRequestOrders); //Assigned orders

            console.log('response.scheduleRequestOrders', response.scheduleRequestOrders);

            if (response.scheduleRequestOrders.length > 0 ||
              this.allRequestedOrders.length == 0) {
              this.loadResult();
            }
            else {
              this.isLoading = false;
              this.isLoadingResults = false; //if nothing to fetch only set as false
              console.log('No ned to call');
            }

          } else {
            this.isLoading = this.allRequestedOrders.length == 0 ? true : false;
          }

        }, () => {
          this.isLoading = false;
          this.isLoadingResults = false;
        })

  }

  /**
* Set the paginator and sort after the view init since this component will
* be able to query its view for the initialized paginator and sort.
*/
  ngAfterViewInit() {


    if (this.scheduleRequestSource) {
      this.scheduleRequestSource.paginator = this.scheduleRequestPaginator;
      this.scheduleRequestSource.sort = this.scheduleRequestSort;
    }

  }

  ngOnDestroy() {
    this.onScheduleRequestChangedSubscription.unsubscribe();
  }

  loadResult() {

    this.allRequestedOrders = _.uniqBy(this.allRequestedOrders, 'orderId');
    this.allRequestedOrders = _.orderBy(this.allRequestedOrders, 'createdAt', 'desc');
    // console.log('loadResult this.allRequestedOrders', this.allRequestedOrders);
    this.assignDataSource(this.allRequestedOrders);
  }

  assignDataSource(orders) {
    this.isLoading = false;
    // console.log('orders', orders);
    this.scheduleRequestSource = new MatTableDataSource(orders);
    this.scheduleRequestSource.paginator = this.scheduleRequestPaginator;
    this.scheduleRequestSource.sort = this.scheduleRequestSort;
    this.orderCount = this.allRequestedOrders.length;

    if ((Math.ceil(this.orderCount / this.pageSize)) == this.currentPageIndex + 1) {  //Check page laste page of total orders
      // case : some case 25 item load - 76 of 100 in 100 - data load next data
      this.callNextSetOfOrders(); //If so , call next set of data
    } else {
      this.isLoadingResults = false; //if nothing to fetch only set as false
    }

    this.highLightFirstRow();
  }

  //To get current page index
  onPaginateChange(event) {
    // console.log('event', event);

    this.currentPageIndex = event.pageIndex; //Index on total page ( 0,1,2,3...)
    this.pageSize = event.pageSize; //Data per page (5,10,15 ....)
    // this.pageLength = event.length;  //Page length (10,20 ....)

    // Check data reach end of data
    this.callNextSetOfOrders();
  }

  callNextSetOfOrders() {

    if (this.hasNextPage) {

      // Check data reach end of data
      if ((Math.ceil(this.orderCount / this.pageSize)) == this.currentPageIndex + 1) {

        this.orderCount = this.allRequestedOrders.length; //It should get all orders count

        this.isLoadingResults = true;
        //When it reach end of data it should get next set of data
        this.sideNavService.fetchOrderStatus('', this.endCursor);

      } else {
        this.orderCount = this.orderCount == 0 ? this.allRequestedOrders.length : this.orderCount;
      }
    } else {
      console.log('reached end');
    }

  }

  highLightFirstRow() {
    (this.from == 'initial' && this.allRequestedOrders.length > 0) ?
      this.selectedId = this.allRequestedOrders[0].orderId : '';

    console.log('this.selectedId ', this.selectedId);
  }
  /** Based on row select- Highlight row */
  onSelect(selected) {
    this.selectedId = selected.orderId;
  }

  //Detail button function call
  openDetail(order) {
    this.ecommerceOrderService.getOrder(order.orderId).then((singleOrder: any) => {
      this.dialog.open(DetailDialogComponent,
        {
          data: {
            orderId: order && order.orderId,
            buyerProperty: order && order.buyerProperty,
            city: singleOrder && singleOrder.billing && singleOrder.billing.city,
            state: singleOrder && singleOrder.billing && singleOrder.billing.state,
            postCode: singleOrder && singleOrder.billing && singleOrder.billing.postcode,
            agentName: singleOrder && singleOrder.billing && singleOrder.billing.first_name,
          },
          width: 'calc(100% - 60%)',
          height: 'calc(100% - 50%)',
        }
      );
    }
    );
  }
}


export interface RequestedOrdersData {

  orderId: string,
  insreportid: string;
  scheduleRequestDate: string,
  contactName: string;
  propertyAddress: string;
  contactEmail: string;
  contactPhone: string;
  additionalShare: string;
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/customer-toggle-request/customer-toggle-request.component.ts